<section id="about" >
    <div class="container">


    <header class="section-header">
     
      <h1 class="section-title" style="text-align: center;">Point of Sale Software Solution</h1>
     
    </header>
    <div class="row row-eq-height justify-content-center">
        <div class="row about-container">

          
            <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp">
             
              <div class="icon-box wow fadeInUp">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
                <h4 class="title"><a href="">Sales Register</a></h4>
                <p class="description">Sales Dashboard is designed to make your transactions more efficient which helps you to better server customers.</p>
              </div>
  
              <div class="icon-box wow fadeInUp" data-wow-delay="0.2s">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                <h4 class="title"><a href="">Inventory Management</a></h4>
                <p class="description">Organize products by Department,category, size, pack, location, brand, group and vendor.</p>
              </div>
  
              <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                <h4 class="title"><a href="">Employee Management</a></h4>
                <p class="description">Allow employees to clock in directly from the register and track their hours in BackOffice with the Time Clock report.
                  </p>
              </div>
  
              <div class="icon-box wow fadeInUp">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                  <h4 class="title"><a href="">Purchase Order Management</a></h4>
                  <p class="description">Control and track purchasing of products from suppliers hepls you to reordring. </p>
                </div>

                <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                    <div class="icon"><i class="fa fa-check-circle"></i></div>
                    <h4 class="title"><a href="">Customer Management</a></h4>
                    <p class="description">Customer management helps you to learn more about your customers contact info and their order history</p>
                  </div>
  
                  <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                      <div class="icon"><i class="fa fa-check-circle"></i></div>
                      <h4 class="title"><a href="">User Role Management</a></h4>
                      <p class="description">Assign cashier and manager privileges for added control over register functions, such as pay-ins/payouts, discounts, or returns.
                        </p>
                    </div>
                    <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                        <div class="icon"><i class="fa fa-check-circle"></i></div>
                        <h4 class="title"><a href="">Sales Promotion</a></h4>
                        <p class="description">Create sales promotion for specific time period and volume on any products without updating the price manually.</p>
                      </div>

                      <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                          <div class="icon"><i class="fa fa-check-circle"></i></div>
                          <h4 class="title"><a href="">Offline Registers</a></h4>
                          <p class="description">Offline mode simply saves all of your transactions locally and then automatically uploads once you're reconnected to the server</p>
                        </div>
                     

                        <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                            <div class="icon"><i class="fa fa-check-circle"></i></div>
                            <h4 class="title"><a href="">On Shelf Inventory Tracking</a></h4>
                            <p class="description">Orgnize your on shelf inventory by updating the location and required shelf quantity. </p>
                          </div>

                          <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                              <div class="icon"><i class="fa fa-bar-chart"></i></div>
                              <h4 class="title"><a href="">Coin Dispenser Integration</a></h4>
                              <p class="description">Coin dispenser can save between 5 to 8 seconds off of each transaction on each register.</p>
                            </div>

                           

                              <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                                  <h4 class="title"><a href="">Reports & Analytics</a></h4>
                                  <p class="description">View, analyze and export sales by staff members, location, time period, or customers.</p>
                                </div>

                                <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                                    <div class="icon"><i class="fa fa-check-circle"></i></div>
                                    <h4 class="title"><a href="">X & Z Reports</a></h4>
                                    <p class="description">Check summaries of a batch register activity during and after the shift, including opening/closing drawer amounts, and much more.
                                      </p>
                                  </div>

                                  <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                                    <div class="icon"><i class="fa fa-check-circle"></i></div>
                                    <h4 class="title"><a href="">POS System for Small Business</a></h4>
                                    <p class="description">We have been offering easiest POS solutions for over 27 years to small & large businesses. Whether it’s a restaurant or inventory our POS system is used by retailers of all sizes to manage sales, customers, inventory, invoices, tax and many other operations. 
                                      We have been recognized as the most trusted & reliable POS system provider by thousands of satisfied customers. Unify in-store and online sales, track payments, inventory, and build strong relationships with your customers & vendors. Grow your business with simplified Point of sale system.
                                      </p>
                                  </div>
            </div>
           
  
  
            <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp">
             

              <div class="icon-box wow fadeInUp">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                  <h4 class="title"><a href="">Speedy Checkout</a></h4>
                  <p class="description">Speed through customer transactions easily in efficient way on your register.
                    </p>
                </div>

                <div class="icon-box wow fadeInUp">
                    <div class="icon"><i class="fa fa-check-circle"></i></div>
                    <h4 class="title"><a href="">Multiple/Split Payment Methods</a></h4>
                    <p class="description">Accept multiple payment types for a single transaction or divide a single check numerous way with just a few quick taps.
                      </p>
                  </div>
                  <div class="icon-box wow fadeInUp">
                      <div class="icon"><i class="fa fa-check-circle"></i></div>
                      <h4 class="title"><a href="">Short-cut Keys</a></h4>
                      <p class="description">Create your own shortcut for most setting items on the dashboard for speedy checkouts. </p>
                    </div>
                    <div class="icon-box wow fadeInUp">
                        <div class="icon"><i class="fa fa-check-circle"></i></div>
                        <h4 class="title"><a href="">Sales returns/Refunds</a></h4>
                        <p class="description">Perform efficient returns and issue customer refunds from current or previous shifts, even without a receipt present.
                          </p>
                      </div>
      
                      <div class="icon-box wow fadeInUp">
                          <div class="icon"><i class="fa fa-check-circle"></i></div>
                          <h4 class="title"><a href="">Bulk Inventory Updates</a></h4>
                          <p class="description">Manage and update multiple items simultaneously all at once without updating manually.
                            </p>
                        </div>
                        <div class="icon-box wow fadeInUp">
                            <div class="icon"><i class="fa fa-check-circle"></i></div>
                            <h4 class="title"><a href="">Inventory Counting</a></h4>
                            <p class="description">Use a scanner to count all your inventory digitally rather than manually. Makes your inventory counting easier.</p>
                          </div>
                          <div class="icon-box wow fadeInUp">
                              <div class="icon"><i class="fa fa-check-circle"></i></div>
                              <h4 class="title"><a href="">Group Discount</a></h4>
                              <p class="description">Define promotions to allow discounts for a specific combination of products.</p>
                            </div>
                          <div class="icon-box wow fadeInUp">
                              <div class="icon"><i class="fa fa-check-circle"></i></div>
                              <h4 class="title"><a href="">Stock Transfer</a></h4>
                              <p class="description">Parent item stock will be automatically adjusted on every sales transaction of child item.  </p>
                            </div>
                            <div class="icon-box wow fadeInUp">
                                <div class="icon"><i class="fa fa-check-circle"></i></div>
                                <h4 class="title"><a href="">Label Printing</a></h4>
                                <p class="description">Print barcode labels for all your inventory items directly from your Back Office from any  computer.</p>
                              </div>
                              <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                                  <h4 class="title"><a href="">Camera Integration</a></h4>
                                  <p class="description">Camera Integration can help you to video record all your transactions at register locations with NVR/DVR.</p>
                                </div>

                                
                            <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                                <div class="icon"><i class="fa fa-check-circle"></i></div>
                                <h4 class="title"><a href="">Real-Time Notifications </a></h4>
                                <p class="description">Know precisely when batches are opened & closed, which employee it was, and the amount in the cash drawer with push notifications.</p>
                              </div>

                              <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                                  <h4 class="title"><a href="">Tax Calculation</a></h4>
                                  <p class="description">Taxes are automatically calculated based on tax settings. If needed, you can disable taxes or set custom taxes for a specific product.</p>
                                </div>
                            
            </div>
          </div>

          <div class="row" >
              <div class="col-2" >
             
            </div>
            <div class="col-8" >
                <img src="../assets/img/pos.jpg" class="img-fluid" alt="" >
              </div>
              <div class="col-2" >
                 
                </div>
          </div>
         
      </div>
                    
  </div>
</section>